export const digitsAndWords = /^(?=.*[A-Za-z])(?=.*\d).+$/;
export const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
export const digitsRegex = /^\d+$/;
export const cyrillicWithSpacesRegex = /^[А-Яа-яЁё\s]+$/;
export const phoneRegex = /^\+7\d{10}$/;
export const errorCodeFieldRegex = /^invalid_(.*?)(?:_format)?$/;
